module.exports = __webpack_public_path__ + "img/172.52e9a036.jpg";